import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import useAxios from "../services/useAxios";
import Invoice from "../components/create-order-page/Invoice";

import "../components/print-factor-page/print-factor-page-style.scss";
import InfoUser from "../components/print-factor-page/InfoUser";

import { TimeStampToJalali, irancoverData } from "../utils/helperFunction";

export default function PrintFactorPage() {
  const { orderId } = useParams();

  const { execute: getOrderApi } = useAxios("order/get_orders");

  const [orderData, setOrderData] = useState({});

  useEffect(() => {
    async function loadPage() {
      await getOrderApi({ order_id: orderId }).then((res) => {
        let result = res?.result[0] ?? [];
        let resultTemp = {
          ...result,
          customer: {
            title:
              result?.customer[0]?.corporate == 1
                ? result?.customer[0]?.company_name
                : `${result?.customer[0]?.firstname} ${result?.customer[0]?.lastname}`,
            ...result?.customer[0],
            postalCode: result?.recipient_postalcode,
            custom_address: result?.delivery_address,
          },
          items: result?.order_items?.map((v) => {
            return {
              ...v,
              json: JSON.parse(v?.json) ?? [],
              product: {
                ...v?.product[0],
                cover_path: v?.product?.cover_path ?? "",
                label: v?.product[0]?.title ?? "",
              },
            };
          }),
        };
        setOrderData(resultTemp ?? []);
      });
    }
    loadPage();
  }, []);

  return (
    <div
      style={{ width: "99%" }}
      id="factor-page-print"
      className="mx-auto my-5 print-factor-page-style "
    >
      <div className="d-flex justify-content-between  px-4">
        <div style={{ width: 90 }}></div>
        <h3 className="align-self-center font-extra-bold text-decoration-underline">
          صورتحساب فروش کالا
        </h3>
        <div className="fw-bold" style={{ lineHeight: 1.9, fontSize: 10 }}>
          <div>شماره سریال: {orderData?.id}</div>
          <div className="ms-4">
            تاریخ :
            {TimeStampToJalali(
              parseInt(orderData?.order_date) * 1000,
              "YYYY/MM/DD"
            )}
          </div>
        </div>
      </div>
      <InfoUser objectData={irancoverData} title="مشخصات فروشنده" />
      <InfoUser
        objectData={orderData?.customer ?? {}}
        more_address_data={false}
        title="مشخصات خریدار"
      />
      <Invoice print={true} dataFactor={orderData} />
    </div>
  );
}
